import { z } from "zod";

export const LoginSchema = z.object({
  email: z.string().nonempty({ message: "Email is required" }).email({
    message: "Must be a valid email",
  }),
  password: z.string().nonempty({ message: "Password is required" }),
});
